export default {
  SponsorCode: 'Mã nhà tài trợ',
  BudgetYear: 'Niên độ ngân sách',
  ShowRefNo: 'Hiển thị số chứng từ',
  ShowRefDate: 'Hiển thị ngày chứng từ',
  ShowRevicer: 'Hiển thị thông tin đơn vị nhận tiền',

  Labels: {
    Reciever: 'Người nhận tiền',
    receivingUnit: 'Đơn vị nhận tiền',
    IdentityNumber: 'CMND',
    ShowReceiver: 'Hiển thị đơn vị nhận tiền',
  },
};
